export const RECOMMENDATION_INVALID_FORM_FIELD_LABELS: Record<string, string> = {
  auditId: 'Audit ID',
  auditDefinition: 'Audit Definition',
  recommendationTitle: 'Recommendation Title (Generated)',
  title: 'Recommendation Title',
  isSpecialAudit: 'Special Audit',
  plant: 'Plant',
  recommendationId: 'Recommendation ID',
  priority: 'Priority',
  currentDeadlineDate: 'Current Deadline Date',
  status: 'Status',
  shortRemarkToAssessor: 'Short Remark To Assessor',
  assessmentCoordinator: 'Assessment Coordinator',
  commentExecution: 'Comment Execution',
  amountCapex: 'Budget in CHF',
  settledDate: 'Settled Date',
  settledBy: 'Settled By',
  settledByName: 'Settled By Name',
  settledDateFinally: 'Finally Settled Date',
  settledByFinally: 'Finally Settled By',
  settledByFinallyName: 'Finally Settled By Name',
  shortText1: "Auditor's Recommendation Details",
  shortText2: "Assessor's Processing Comment",
  sequenceNumber1: 'Rec. No. 1',
  sequenceNumber2: 'Rec. No. 2',
  reportTypeDAFC: 'Report Type DAFC',
  isLegallyRequired: 'Legally Required',
  budget: 'Budget',
  initialDeadline: 'Initial Deadline',
  plantComments: 'Plant Comments',
  category: 'Category',
  concernsName: 'Concerns Name',
  concernsCountry: 'Concerns Country',
  reportingYear: 'Reporting Year',
  legalUnit: 'Legal Unit',
  department: 'Department',
  auditor: 'Audit Dep',
  assessmentCoordinatorName: 'Assessment Coordinator Name',
  legalUnitResponsibles: 'LU responsibles',
  legalUnitResponsiblesNames: 'LU responsibles Names',
  emailAddress: 'Email Address',
  modificationAction: 'Modification Action',
  modificationDate: 'Modification Date',
  modificationStatus: 'Modification Status',
  fileLinkId: 'File Link ID',
  settledRejectReason: 'Settle Reject Reason',
  otherResponsiblesNames: 'Other responsibles Names',
  otherResponsibles: 'Other responsibles',
  prolongationDecision: 'Prolongation Decision',
  prolongationStatus: 'Prolongation Status',
  prolongationHistory: 'Prolongation History',
  prolongationDeadline: 'Prolongation Deadline',
  prolongationRequestDate: 'Prolongation Request Date',
  prolongationRequestBy: 'Prolongation Request By',
  prolongationRequestByName: 'Prolongation Request By Name',
  prolongationGrantedDate: 'Prolongation Granted Date',
  prolongationGrantedBy: 'Prolongation Granted By',
  prolongationGrantedByName: 'Prolongation Granted By Name',
  prolongation: 'Prolongation',
  adjournedReason: 'Adjourned Reason',
  adjournedDate: 'Adjourned Date',
  adjournedBy: 'Adjourned By',
  adjournedByName: 'Adjourned By Name',
  prolongationOtherDate: 'Other Prolongation Date',
  prolongationOtherHistory: 'Other Prolongation History',
  prolongationToAssessor: 'Prolongation To Assessor',
  responsibleAssessment: 'Responsible Assessment',
  responsibleAssessmentName: 'Responsible Assessment Name',
  responsibleAssessmentAzureId: 'Responsible Assessment Azure ID',
  legalUnitResponsiblesCc: 'LU responsibles CC',
  legalUnitResponsiblesCcNames: 'LU responsibles CC Names',
  legalUnitResponsiblesCcAzureIds: 'LU responsibles CC Azure IDs',
  readOthersLegalUnit: 'Read Others Legal Unit',
  readOthersLegalUnitNames: 'Read Others Legal Unit Names',
  readOthersLegalUnitAzureIds: 'Read Others Legal Unit Azure IDs',
  sendReminder0Days: 'Send Reminder 0 Days',
  sendReminder12Month: 'Send Reminder 12 Month',
  sendReminder14Days: 'Send Reminder 14 Days',
  sendReminder30DaysBefore: 'Send Reminder 30 Days Before',
  sendReminder1Month: 'Send Reminder 1 Month',
  sendReminder3Month: 'Send Reminder 3 Month',
  sendReminderAll3Months: 'Send Reminder All 3 Months',
  authorsAuditor: 'Authors Auditor',
  authorsBinGen: 'Authors BinGen',
  authorsRec: 'Authors Rec',
  keypersons: 'Keypersons',
  myAttention: 'My Attention',
  readersBusinessGroup: 'Readers Business Group',
  readersLegalUnit: 'Readers Legal Unit',
  readersResponsible: 'Readers Responsible',
  decision: 'Decision',
  createdByUserId: 'Created By User ID',
  id: 'ID',
  createdAt: 'Created At',
  modifiedAt: 'Modified At',
  createdBy: 'Created By',
  modifiedBy: 'Modified By',
  createdTick: 'Created Tick',
  modifiedTick: 'Modified Tick',
  newDeadline: 'New Deadline'
};
